import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import { useActiveOrganization } from '@/hooks/useActiveOrganization';
import { queryKeys } from '@/lib/query-keys';
import { executeQuery } from '@/lib/execute-query';
import { Action } from '@/business/types/action.types';
import type {
  GetDashboardStatsInput,
  GetDashboardStatsOutput,
} from '@/types/generated';

export function useDashboardStatsQuery() {
  const { user } = useAuth();
  const { activeOrganizationId } = useActiveOrganization();

  return useQuery({
    queryKey: queryKeys.dashboardStats.forUser(user!.id, activeOrganizationId),
    queryFn: () =>
      executeQuery<GetDashboardStatsInput, GetDashboardStatsOutput>(
        Action.GET_DASHBOARD_STATS,
        {
          user_id: user!.id,
        }
      ),
    staleTime: 1000 * 60, // 60s
    enabled: !!user?.id,
  });
}
